import { useQuery } from '@tanstack/react-query';
import { CriticalInfoDocument } from '@/types/CriticalInfo.ts';
import { getHouseCriticalInfoHousesHouseIdCriticalInfoGetQueryKey } from '@/client/@tanstack/react-query.gen.ts';
import { Documents } from '@/client';

export function getCriticalInfoQueryConfig(houseId: number) {
	return {
		queryKey: getHouseCriticalInfoHousesHouseIdCriticalInfoGetQueryKey({
			path: { house_id: houseId },
		}),
		queryFn: async ({ signal }: { signal?: AbortSignal }) => {
			const { data } = await Documents.getHouseCriticalInfoHousesHouseIdCriticalInfoGet({
				path: { house_id: houseId },
				signal,
				throwOnError: false,
			});
			return data ?? null;
		},
	};
}

export const useCriticalInfo = (houseId: number) => {
	const query = useQuery({
		...getCriticalInfoQueryConfig(houseId),
		retry: false,
		throwOnError: false,
	});

	return {
		...query,
		data: query.data as CriticalInfoDocument | undefined,
		exists: !!query.data && !query.error,
	};
};
